export default __webpack_public_path__ + "static/broderie6.inspirations-906c75002d1f1250f782ce8093266c54.jpg";